import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p className="loading-text">Loading Quran...</p>
    </div>
  );
};

export default LoadingSpinner;
